import { render, staticRenderFns } from "./Suspend.html?vue&type=template&id=0a142e0c&external"
import script from "./Suspend.js?vue&type=script&lang=js&external"
export * from "./Suspend.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports